import { visitTemplatesTranslationKeys } from '../../../translations';
import { VisitTemplateFormController } from '../VisitTemplateForm.types';

import { VisitTemplateFormTextEditor } from './VisitTemplateFormTextEditor';

type VisitTemplateFormPhysicalExaminationTextareaProps = Pick<VisitTemplateFormController, 'register' | 'control'>;

export const VisitTemplateFormPhysicalExaminationTextarea = (
   props: VisitTemplateFormPhysicalExaminationTextareaProps
): JSX.Element => {
   return (
      <VisitTemplateFormTextEditor
         register={props.register}
         control={props.control}
         fieldName={'subjectiveAssessment'}
         label={visitTemplatesTranslationKeys.subjectiveAssessment}
         placeholder={visitTemplatesTranslationKeys.enterSubjectiveAssessment}
         testId={'subjectiveAssessment'}
      />
   );
};
